export type TicketAttachmentKind = 'image' | 'pdf' | 'spreadsheet' | 'other';

const IMAGE_MIME_TYPES = new Set([
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
]);
const SPREADSHEET_MIME_TYPES = new Set([
  'text/csv',
  'application/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]);

export function ticketAttachmentKind(
  nameOrPath: string,
  mimeType = '',
): TicketAttachmentKind {
  const extension = attachmentExtension(nameOrPath);
  const normalizedMime = mimeType.toLowerCase();

  if (['png', 'jpg', 'jpeg', 'gif'].includes(extension) || IMAGE_MIME_TYPES.has(normalizedMime)) {
    return 'image';
  }
  if (extension === 'pdf' || normalizedMime === 'application/pdf') return 'pdf';
  if (['csv', 'xlsx'].includes(extension) || SPREADSHEET_MIME_TYPES.has(normalizedMime)) {
    return 'spreadsheet';
  }
  return 'other';
}

export function isTicketOrdinaryAttachment(file: File): boolean {
  return ticketAttachmentKind(file.name, file.type) !== 'other';
}

function attachmentExtension(nameOrPath: string): string {
  const cleanPath = nameOrPath.split(/[?#]/, 1)[0];
  const match = cleanPath.match(/\.([^.\\/]+)$/);
  return match?.[1].toLowerCase() ?? '';
}
